import { useEffect, useState } from "react";
import { SpeakerHigh, SpeakerX } from "@phosphor-icons/react";
import { isSoundMuted, setSoundMuted, playSound } from "@/lib/sounds";

export const SoundToggle = ({ compact = false }) => {
  const [muted, setMuted] = useState(isSoundMuted());

  useEffect(() => {
    const onChange = (e) => setMuted(!!(e.detail && e.detail.muted));
    window.addEventListener("ridexelite-sound-muted", onChange);
    return () => window.removeEventListener("ridexelite-sound-muted", onChange);
  }, []);

  const toggle = () => {
    const next = !muted;
    setSoundMuted(next);
    setMuted(next);
    // Confirm sound only when un-muting
    if (!next) playSound("tock");
  };

  const Icon = muted ? SpeakerX : SpeakerHigh;
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="sound-toggle"
      aria-label={muted ? "Unmute click sounds" : "Mute click sounds"}
      title={muted ? "Sounds off" : "Sounds on"}
      className={`inline-flex items-center justify-center rounded-full border transition-colors ${
        muted
          ? "border-white/10 text-zinc-500 hover:text-white hover:border-white/30"
          : "border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10"
      } ${compact ? "w-9 h-9" : "w-10 h-10"}`}
    >
      <Icon size={16} weight={muted ? "regular" : "duotone"} />
    </button>
  );
};

export default SoundToggle;
